import React from "react";

export const PlayToneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <rect
        x="0.5"
        y="1.32739"
        width="23"
        height="23"
        rx="11.5"
        stroke="#12B6EA"
      />
      <mask
        id="mask0_15789_5933"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.827393" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_15789_5933)">
        <path
          d="M15.5001 18.9234L5.92334 12.8274L15.5001 6.73145V18.9234ZM14.0001 16.1774V9.47745L8.73084 12.8274L14.0001 16.1774Z"
          fill="#12B6EA"
        />
      </g>
    </svg>
  );
};
